import apiClient from "@/services/axios";

export async function post(id) {
  var response = await apiClient.post(process.env.VUE_APP_CRM_API_BASE_URL + '/MasterCampaigns/Send', { masterCampaignId: id });
  if (response) {
    return response.data;
  }

  throw new Error("Unable to update master campaign.");
}
